import produce from 'immer';

import {
  WORK_SCHEDULE_CREATE_FAILURE,
  WORK_SCHEDULE_CREATE_SUCCESS,
  WORK_SCHEDULE_FETCH_FAILURE,
  WORK_SCHEDULE_FETCH_SUCCESS,
  WORK_SCHEDULE_UPDATE_FAILURE,
  WORK_SCHEDULE_UPDATE_SUCCESS,
} from '@actions/workSchedule';

const initialState: IWorkScheduleStore = {
  workSchedule: null,
  isFetching: false,
  error: null,
};

export default (state: IWorkScheduleStore = initialState, action: any) =>
  produce(state, (draftState: IWorkScheduleStore) => {
    switch (action.type) {
      case WORK_SCHEDULE_FETCH_SUCCESS:
      case WORK_SCHEDULE_CREATE_SUCCESS:
      case WORK_SCHEDULE_UPDATE_SUCCESS:
        draftState.workSchedule = action.response;
        draftState.isFetching = true;
        draftState.error = null;

        return;

      case WORK_SCHEDULE_FETCH_FAILURE:
      case WORK_SCHEDULE_CREATE_FAILURE:
      case WORK_SCHEDULE_UPDATE_FAILURE:
        draftState.isFetching = true;
        draftState.error = action.error;

        return;
    }
  });
